<script>
    import {fade} from 'svelte/transition';
    import R from "../../lib/requests";
    import app from "../../stores/app";
    import user from "../../stores/user";
    import {setFocusTo} from "../../lib/lib";
    import PasswordControl from "../controls/PasswordControl.svelte";

    let email = '';
    let password = '';
    let error = false;

    const login = () => {

        const onSuccess = result => {
            user.setUser(result);
            app.setViewBy($user.id);
        }

        const onFailure = err => {
            error = true;
            setFocusTo('login-password');
        };

        error = false;
        R.handle(R.workspace.login, {email, password}, onSuccess, onFailure);
    }

    setFocusTo('login-email');
</script>

<div class="login-overlay" transition:fade="{{ duration: 100 }}">
    <div class="login-content">
        <div class="login-inner" class:error={ error }>
            <div class="panel panel-default login-panel">
                <div class="panel-body panel-pad">
                    <form on:submit|preventDefault|stopPropagation="{ login }">
                        <div class="form-group">
                            <label>Email</label>
                            <input type="text" class="form-control" id="login-email" bind:value="{ email }" required>
                        </div>
                        <div class="form-group">
                            <label>Κωδικός</label>
                            <PasswordControl id="login-password" bind:value="{ password }" required/>
                        </div>
                        <button class="btn btn-primary">ΕΙΣΟΔΟΣ</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .login-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #f2f6f8;
        z-index: 9900;
    }

    .login-content {
        position: absolute;
        width: 80%;
        max-width: 300px;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
    }

    .login-inner {
        position: relative;
        max-width: 300px;
    }

    .login-inner.error {
        animation: shake 0.82s cubic-bezier(.36, .07, .19, .97) both;
        transform: translate3d(0, 0, 0);
        backface-visibility: hidden;
        perspective: 1000px;
    }
</style>